<script>
  import { _ } from '@sveltia/i18n';
  import { Divider, Menu, MenuItem } from '@sveltia/ui';

  import AppInstallMenuItem from '$lib/components/global/toolbar/items/app-install-menu-item.svelte';
  import ShortcutsMenuItem from '$lib/components/help/shortcuts-menu-item.svelte';
  import SettingsDialog from '$lib/components/settings/settings-dialog.svelte';
  import { goto, openProductionSite } from '$lib/services/app/navigation';
  import { canShowMobileSignInDialog, showMobileSignInDialog } from '$lib/services/app/onboarding';
  import { backend, backendName } from '$lib/services/backends';
  import { user } from '$lib/services/user/account.svelte';
  import { signOut } from '$lib/services/user/auth.svelte';
  import { env } from '$lib/services/user/env.svelte';
  import { prefs } from '$lib/services/user/prefs.svelte';
  import { openNewTab } from '$lib/services/utils/window';

  /**
   * @typedef {object} Props
   * @property {import('@sveltia/ui').MenuButton} [menuButton] Menu button.
   */

  /** @type {Props} */
  let {
    /* eslint-disable prefer-const */
    menuButton,
    /* eslint-enable prefer-const */
  } = $props();

  let showPrefsDialog = $state(false);

  const isLocalRepo = $derived(backendName.current === 'local');
  const isTestRepo = $derived(backendName.current === 'test-repo');
</script>

<Menu ariaLabel={_('account')}>
  <MenuItem
    label={isLocalRepo
      ? _('working_with_local_repo')
      : isTestRepo
        ? _('working_with_test_repo')
        : _('signed_in_as_x', { values: { name: user.account?.login } })}
    disabled={isLocalRepo || isTestRepo}
    onclick={() => {
      openNewTab(user.account?.profileURL);
    }}
  />
  <Divider />
  <MenuItem
    label={_('live_site')}
    onclick={() => {
      openProductionSite();
    }}
  />
  {#if prefs.devModeEnabled}
    <MenuItem
      label={_('git_repository')}
      disabled={!backend.current?.repository?.treeBaseURL}
      onclick={() => {
        openNewTab(backend.current?.repository?.treeBaseURL);
      }}
    />
    <MenuItem
      label={_('cms_config')}
      onclick={() => {
        goto('/config', { transitionType: 'forwards' });
      }}
    />
  {/if}
  <Divider />
  <MenuItem
    label={_('settings')}
    onclick={() => {
      if (env.isSmallScreen) {
        goto('/settings', { transitionType: 'forwards' });
      } else {
        showPrefsDialog = true;
      }
    }}
  />
  <!-- When dev mode is enabled, the shortcuts menu item appears in the Help menu -->
  {#if !prefs.devModeEnabled}
    <ShortcutsMenuItem {menuButton} />
  {/if}
  {#if canShowMobileSignInDialog.current}
    <MenuItem
      label={_('sign_in_with_mobile')}
      onclick={() => {
        showMobileSignInDialog.current = true;
      }}
    />
  {/if}
  <AppInstallMenuItem />
  <Divider />
  <MenuItem
    label={_('sign_out')}
    onclick={async () => {
      // Wait a bit before the menu is closed
      window.requestAnimationFrame(() => {
        signOut();
      });
    }}
  />
</Menu>

<SettingsDialog
  bind:open={showPrefsDialog}
  onClose={() => {
    menuButton?.focus();
  }}
/>
